import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100vh', background: '#0a0c1c', color: '#eee8ff', fontFamily: 'inherit',
          padding: '24px', textAlign: 'center',
        }}>
          <h1 style={{ fontSize: '18px', fontWeight: 700, letterSpacing: '2px', marginBottom: '12px' }}>
            SYSTEM MALFUNCTION
          </h1>
          <p style={{ fontSize: '13px', color: 'rgba(220,210,255,0.55)', marginBottom: '20px' }}>
            Something went wrong. Please reload the application.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px', borderRadius: '6px', border: '1px solid rgba(123,104,238,0.3)',
              background: 'linear-gradient(135deg,rgba(123,104,238,0.2),rgba(228,41,242,0.1))',
              color: '#7b68ee', fontSize: '12px', fontWeight: 700, cursor: 'pointer',
              letterSpacing: '1px',
            }}
          >
            RELOAD
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
